import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.workspaceService = 'http://localhost:7001/workspace/';

export default class WorkspaceService {
  async getUserWorkspaces(user_id) {
    return await axiosInstance
      .get(`${envUrls.workspaceService}get_user_workspaces/${user_id}`)
      .then((response) => {
        return response.data;
      });
  }
  async createWorkspace(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}create`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async updateWorkspace(payload) {
    return await axiosInstance
      .patch(`${envUrls.workspaceService}update`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async updateWorkspacesSortOrder(payload) {
    return await axiosInstance
      .patch(`${envUrls.workspaceService}update_sort_order`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async deleteWorkspace(workspace_id) {
    return await axiosInstance
      .delete(`${envUrls.workspaceService}delete/${workspace_id}`)
      .then((response) => {
        return response.data;
      });
  }
  async deleteTrackedEntitiesFromWorkspace(payload) {
    return await axiosInstance
      .post(
        `${envUrls.workspaceService}delete_tracked_entities_from_workspace`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }
  async linkUnlinkScan(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}link_unlink_scan`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async linkUnlinkScans(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}link_unlink_scans`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async getScanWorkspaceIds(scan_id) {
    return await axiosInstance
      .get(`${envUrls.workspaceService}get_scan_workspace_ids/${scan_id}`)
      .then((response) => {
        return response.data;
      });
  }
  async getWorkspaceLinkedScans(workspace_id) {
    return await axiosInstance
      .get(
        `${envUrls.workspaceService}get_workspace_linked_scans/${workspace_id}`
      )
      .then((response) => {
        return response.data;
      });
  }
  async unlinkScanFromUserWorkspaces(payload) {
    return await axiosInstance
      .post(
        `${envUrls.workspaceService}unlink_scan_from_user_workspaces`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }
  async unlinkScanFromAllWorkspaces(payload) {
    return await axiosInstance
      .post(
        `${envUrls.workspaceService}unlink_scan_from_all_workspaces`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }
  async addTrackedEntity(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}add_tracked_entity`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async deleteTrackedEntityFromWorkspaces(payload) {
    return await axiosInstance
      .post(
        `${envUrls.workspaceService}delete_tracked_entity_from_workspaces`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }
  async fetchPersonMetadata(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}fetch_person_metadata`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async fetchAlerts(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}fetch_alerts`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async markAlertsRead(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}mark_alerts_read`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async markAllAlertsRead(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}mark_all_alerts_read`, payload)
      .then((response) => {
        return response.data;
      });
  }
  async toggleAlertsOnOff(payload) {
    return await axiosInstance
      .post(`${envUrls.workspaceService}toggle_alerts_on_off`, payload)
      .then((response) => {
        return response.data;
      });
  }
}
